import { render } from "./index.vue?vue&type=template&id=77219974&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=77219974&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77219974"]])

export default __exports__